import { SUBCLUSTERS } from '../subclusters.js';

const LEGAL_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.LEGAL_REQUESTS,
        },
        {
            key: SUBCLUSTERS.PROCUREMENT,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CLIENT_PROJECTS,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
    ],
};

export { LEGAL_CLUSTER };
